import { render, staticRenderFns } from "./DetailHead.vue?vue&type=template&id=55f64ff5&"
import script from "./DetailHead.vue?vue&type=script&lang=js&"
export * from "./DetailHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports